import { UserUtils } from 'utils'

/**
 * Utility class Adaptive Learning
 */
class AdaptiveLearningUtils {
  private readonly DB_NAME = 'AdaptiveLearningDB'
  private readonly STORE_NAME = 'VisitedUsers'
  private db: IDBDatabase | null = null

  /**
   * Initializes the IndexedDB database.
   */
  private async initDB(): Promise<IDBDatabase | void> {
    return new Promise(resolve => {
      if (this.db) return resolve(this.db)

      const request = indexedDB.open(this.DB_NAME, 1)

      request.onupgradeneeded = event => {
        const db = (event.target as IDBOpenDBRequest).result
        if (!db.objectStoreNames.contains(this.STORE_NAME)) {
          db.createObjectStore(this.STORE_NAME, { keyPath: 'id' })
        }
      }

      request.onsuccess = () => {
        this.db = request.result
        resolve(this.db)
      }

      request.onerror = () => {
        console.warn('Failed to create IndexedDB database:', request.error)
        resolve()
      }
    })
  }

  /**
   * Checks if the user has visited.
   */
  async isVisited(): Promise<boolean> {
    const db = await this.initDB()
    if (!db) return false

    return new Promise(resolve => {
      const transaction = db.transaction(this.STORE_NAME, 'readonly')
      const store = transaction.objectStore(this.STORE_NAME)
      const user = UserUtils.getUserAccountInfo()
      const request = store.get(user.login)

      request.onsuccess = () => {
        resolve(!!request.result)
      }

      request.onerror = () => {
        console.warn('Error retrieving data from indexedDB:', request.error)
        resolve(false)
      }
    })
  }

  /**
   * Marks the user as visited.
   */
  async markAsVisited() {
    const db = await this.initDB()
    if (!db) return

    return new Promise<void>(resolve => {
      const transaction = db.transaction(this.STORE_NAME, 'readwrite')
      const store = transaction.objectStore(this.STORE_NAME)
      const user = UserUtils.getUserAccountInfo()
      const request = store.put({ id: user.login })

      request.onsuccess = () => resolve()
      request.onerror = () => {
        console.warn('Error storing data to indexedDB:', request.error)
        resolve()
      }
    })
  }
}

export default new AdaptiveLearningUtils()
